import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  RefOk,
  RefResult,
  createRefSession,
  getRefSession,
  getRefByBillerId,
  clearRefSession,
  getAllActiveForBiller,
} from "../../../utils/refId/refId";

// Redux state: billerId -> { sessionId -> RefOk }
export type RefIdsState = Record<string, Record<string, RefOk>>;

const initialState: RefIdsState = {};

const refIdsSlice = createSlice({
  name: "refIds",
  initialState,
  reducers: {
    // create new session and persist in Redux state
    createRefIdForBiller: {
      reducer(state, action: PayloadAction<RefOk>) {
        const rec = action.payload;
        if (!state[rec.billerId]) state[rec.billerId] = {};
        state[rec.billerId][rec.sessionId] = rec;
      },
      prepare(billerId: string) {
        const rec = createRefSession(billerId); // utils/refId/refId se
        return { payload: rec };
      },
    },

    // validate existing session (by sessionId)
    validateRefId(
      state,
      action: PayloadAction<{ sessionId: string; billerId: string }>,
    ) {
      const { sessionId, billerId } = action.payload;
      const res: RefResult = getRefSession(sessionId);
      if (!res.ok) {
        // expired/not found → Redux se bhi delete kar do
        if (state[billerId]) {
          delete state[billerId][sessionId];
          if (Object.keys(state[billerId]).length === 0) delete state[billerId];
        }
      } else {
        // refresh Redux snapshot (in case time fields updated)
        state[billerId][sessionId] = res;
      }
    },

    // clear a session manually
    clearRefId(
      state,
      action: PayloadAction<{ sessionId: string; billerId: string }>,
    ) {
      const { sessionId, billerId } = action.payload;
      clearRefSession(sessionId); // utils se cleanup (LS + cookie)
      if (state[billerId]) {
        delete state[billerId][sessionId];
        if (Object.keys(state[billerId]).length === 0) delete state[billerId];
      }
    },
  },
});

export const { createRefIdForBiller, validateRefId, clearRefId } =
  refIdsSlice.actions;
export default refIdsSlice.reducer;

/* ----------- Selectors ----------- */

// Get latest active ref for a biller (shortcut)
export const selectLatestRefForBiller = (
  state: RefIdsState,
  billerId: string,
): RefOk | undefined => {
  const res = getRefByBillerId(billerId);
  return res.ok ? res : undefined;
};

// Get all active sessions for a biller
export const selectAllActiveForBiller = (
  state: RefIdsState,
  billerId: string,
): RefOk[] => {
  return getAllActiveForBiller(billerId);
};

// // src/store/refIds/slice.ts
// import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// import { RefIdMap, loadRefIdMap, saveRefIdMap } from "../../../utils/refId/refId";

// const initialState: RefIdMap = loadRefIdMap();

// const refIdsSlice = createSlice({
//   name: "refIds",
//   initialState,
//   reducers: {
//     setRefId(state, action: PayloadAction<{ billerId: string; refId: string }>) {
//       const { billerId, refId } = action.payload;
//       state[billerId] = refId;
//       saveRefIdMap(state);
//     },
//   },
// });

// export const { setRefId } = refIdsSlice.actions;
// export default refIdsSlice.reducer;
